import React, { memo } from 'react';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';

interface Props {
  color?: string | null;
  label?: string | null;
}

function CategoryCell({ label, color }: Props) {
  if (!label) return <>-</>;
  return (
    <ChipCell label={label} type={colorToChipType(color)} leftIcon="circle" />
  );
}

export default memo(CategoryCell);
